import _ from 'underscore';
import { ApiRailwayRoute } from '@ve/types/railway/ApiRailwayRoute';

type RouteReferenceIndex = {
    [key: string]: ApiRailwayRoute
};

export default ({ routeIds, routeReferenceIndex }: { routeIds: string[], routeReferenceIndex: RouteReferenceIndex }): ApiRailwayRoute[] => _.map(routeIds, (routeId: keyof RouteReferenceIndex) => routeReferenceIndex[routeId]);